import { Center, Group, Table, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react';

import classes from './th.module.css';

interface ThProps {
  children: React.ReactNode;
  reversed: boolean;
  sorted: boolean;
  className?: string;
  onSort(): void;
}

const Th = ({ children, className, onSort, reversed, sorted }: ThProps) => {
  const Icon = sorted ? (reversed ? IconChevronDown : IconChevronUp) : IconSelector;
  return (
    <Table.Th className={`${classes.th} ${className}`}>
      <UnstyledButton onClick={onSort} className={classes.control}>
        <Group justify="center" wrap="nowrap" gap={0}>
          <Text fw={400} fz="sm">
            {children}
          </Text>
          <Center className={classes.icon}>
            <Icon style={{ width: 16, height: 16 }} stroke={1.5} />
          </Center>
        </Group>
      </UnstyledButton>
    </Table.Th>
  );
};

export default Th;
